// # Action Types
//
// Document anything that is non-obvious, ideally everything should be self explanatory

export const SET_PLAYER_OPTIONS = "SET_PLAYER_OPTIONS";
export const SET_USER_DROPDOWN_VISIBLE = "SET_USER_DROPDOWN_VISIBLE";
export const STORY_LOADED = "STORY_LOADED";

// Modal actions
export const SET_CHAPTER_LIST_VISIBLE = "SET_CHAPTER_LIST_VISIBLE";
export const SET_SLIDESHOW_GALLERY_TOGGLE = "SET_SLIDESHOW_GALLERY_TOGGLE";
export const SET_SLIDESHOW_INFO_TOGGLE = "SET_SLIDESHOW_INFO_TOGGLE";
export const SET_STORY_INFO_VISIBLE = "SET_STORY_INFO_VISIBLE";

// Device actions
export const FORCE_DASH_PLAYBACK = "FORCE_DASH_PLAYBACK";
export const FORCE_HLS_PLAYBACK = "FORCE_HLS_PLAYBACK";
export const SET_SCREEN_DIMENSIONS = "SET_SCREEN_DIMENSIONS";
export const SET_USERAGENT = "SET_USERAGENT";
export const SET_BROWSER_LANGUAGES = "SET_BROWSER_LANGUAGES";

// Viewport actions
export const SET_VIEWPORT_DIMENSIONS = "SET_VIEWPORT_DIMENSIONS";
export const SET_VIEWPORT_PIXEL_RATIO = "SET_VIEWPORT_PIXEL_RATIO";

// Window blur
export const WINDOW_BLUR = "WINDOW_BLUR";
export const WINDOW_FOCUS = "WINDOW_FOCUS";

// Route actions
export const SET_ROUTE_DATA = "SET_ROUTE_DATA";

// Control Actions
export const TOGGLE_TOP_NAV_OVERFLOW_CHAPTERS =
  "TOGGLE_TOP_NAV_OVERFLOW_CHAPTERS";

// Runtime flags
export const KEY_DOWN = "KEY_DOWN";
export const KEY_UP = "KEY_UP";

// Loading Actions
export const DASH_JS_LOAD_COMPLETE = "DASH_JS_LOAD_COMPLETE";
export const INITIAL_LOAD_COMPLETE = "INITIAL_LOAD_COMPLETE";
export const VERSE_THREE_LOAD_COMPLETE = "VERSE_THREE_LOAD_COMPLETE";

// Slider Dimensions
export const SET_SLIDER_LEFT = "SET_SLIDER_LEFT";
export const SET_SLIDER_WIDTH = "SET_SLIDER_WIDTH";

// Hot Update Actions
export const UPDATE_HOTSPOT = "UPDATE_HOTSPOT";
export const ADD_HOTSPOT = "ADD_HOTSPOT";

// Story Publish Settings
export const STORY_PUBLISH_SETTINGS_LOADED = "STORY_PUBLISH_SETTINGS_LOADED";

// User interaction
export const CLOSE_USER_NOTIFIER = "CLOSE_USER_NOTIFIER";
export const RECEIVED_USER_INTERACTION = "RECEIVED_USER_INTERACTION";
export const SHOW_USER_NOTIFIER = "SHOW_USER_NOTIFIER";
export const USER_INTERACTION_INITIATED_PLAYBACK =
  "USER_INTERACTION_INITIATED_PLAYBACK";
export const USER_INTERACTION_REPORT_ABUSE = "USER_INTERACTION_REPORT_ABUSE";
export const USER_SHARED_STORY = "USER_SHARED_STORY";

// Ads
export const AD_COMPLETED = "AD_COMPLETED";
export const SET_AD_DURATION = "SET_AD_DURATION";
export const SET_AD_IS_SKIPPABLE = "SET_AD_IS_SKIPPABLE";
export const SET_AD_PLAYING = "SET_AD_PLAYING";
export const SET_AD_SKIP_ALLOWED_NOW = "SET_AD_SKIP_ALLOWED_NOW";
export const USER_REQUESTED_AD_SKIP = "USER_REQUESTED_AD_SKIP";
export const RESET_ADS = "RESET_ADS";
export const SET_IS_READY_FOR_AD_RESET = "SET_IS_READY_FOR_AD_RESET";
export const SET_AD_LOADED = "SET_AD_LOADED";
export const INCREMENT_AD_TRANSITIONS = "INCREMENT_AD_TRANSITIONS";

// Volume
export const SET_VOLUME_MUTED = "SET_VOLUME_MUTED";
export const TOGGLE_VOLUME_MUTED = "TOGGLE_VOLUME_MUTED";
export const SET_INITIALLY_MUTED = "SET_INITIALLY_MUTED";
export const UNMUTE_VOLUME_FROM_UI_ACTIVITY = "UNMUTE_VOLUME_FROM_UI_ACTIVITY";

// Force chapter cover
export const SET_FORCE_CHAPTER_COVER = "SET_FORCE_CHAPTER_COVER";

// Inactivity
export const SET_INACTIVITY = "SET_INACTIVITY";
export const REPORT_ACTIVITY = "REPORT_ACTIVITY";
export const REPORT_UI_ACTIVITY = "REPORT_UI_ACTIVITY";
export const FORCE_INACTIVITY = "FORCE_INACTIVITY";
export const SET_TRANSITIONING = "SET_TRANSITIONING";

// Playback state
export const CHANGE_PLAYBACK_STATE = "CHANGE_PLAYBACK_STATE";
export const DESTROY_PLAYBACK_STATE = "DESTROY_PLAYBACK_STATE";
export const SET_PLAYBACK_STATE_FROM_ALT_DO_NOT_USE_THIS =
  "SET_PLAYBACK_STATE_FROM_ALT_DO_NOT_USE_THIS";
export const SEEK_FORWARD = "SEEK_FORWARD";
export const SEEK_BACK = "SEEK_BACK";

// Captions
export const SET_TEXT_TRACK_LANGUAGE = "SET_TEXT_TRACK_LANGUAGE";
export const SET_TEXT_TRACK_CAPTION_SETTINGS_VISIBILITY =
  "SET_TEXT_TRACK_CAPTION_SETTINGS_VISIBILITY";
export const SET_CAPTIONS_SELECTION_MENU_VISIBILITY =
  "SET_CAPTIONS_SELECTION_MENU_VISIBILITY";

// Cuepoint preview
export const SET_VISIBLE_CUEPOINT_PREVIEW_INDEX =
  "SET_VISIBLE_CUEPOINT_PREVIEW_INDEX";
export const HIDE_CUEPOINT_PREVIEWS = "HIDE_CUEPOINT_PREVIEWS";

// Reset actions
export const PIN_INITIAL_STATE = "PIN_INITIAL_STATE";
export const RESET_INITIAL_STATE = "RESET_INITIAL_STATE";
